import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'

import PageWrapper from '/components/page-wrapper'
import logo from '/assets/images/smartix-logo.png'

import HelpText from '/help/login'
import SmartixSignIn from '/components/login/signin-form'

const LoginForm = () => {

  return (
    <PageWrapper title="Login" HelpText={HelpText}>
      <div className='overflow-y-scroll w-full h-full'>
        <div className="login-hero flex flex-col gap-12 xl:flex-row w-full justify-between items-center xl:items-start pt-16 px-6 xl:px-16">

          <div className='login-hero__brand flex flex-col gap-6 items-center text-center xl:text-left xl:items-start'>
            <div className='login-hero__logo-row flex flex-col gap-6 items-center sm:flex-row'>
              <img src={logo} className="login-hero__logo" />

              <div className='flex flex-col items-center xl:items-start'>
                <div className='smartix home'>SMARTIX</div>
                <div className='studio home'>Studio</div>
              </div>

            </div>

            <div className='tagline text-center w-full'>Keep Your Brand in Their Pocket</div>
          </div>

          <div className="flex items-start justify-center signin-override max-w-xl xl:max-w-none">
            <SmartixSignIn />
          </div>

        </div>
        <div className="m-20 mt-10 text-2xl opacity-70">Emails and texts disappear among the daily flood of messages. Smartix Wallet Passes stay right where your customers can see them — on their phones, ready when needed.
          Whether it’s a document, renewal, reminder, or reward, your message is always visible, always current, and never forgotten. <a href="https://www.smartix.uk" target='_blank'>Discover Smartix<OpenInNewOutlinedIcon className='ml-2'/></a></div>
      </div>
    </PageWrapper>
  )
}

export default LoginForm
